import { combineReducers } from "@reduxjs/toolkit";
import settingReducer from "./features/settingSlice";
import snackbarReducer from "./features/snackbarSlice";
import userReducer from "./features/userSlice";
import dialogReducer from "./features/dialogSlice";
import ownerReducer from "./features/ownerSlice";

const rootReducer = combineReducers({
  settings: settingReducer,
  snackbar: snackbarReducer,
  dialog: dialogReducer,
  user: userReducer,
  owner: ownerReducer,
});

export default rootReducer;
